import { render, staticRenderFns } from "./ProfileAssistantButton.vue?vue&type=template&id=34105ab0&scoped=true"
import script from "./ProfileAssistantButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileAssistantButton.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileAssistantButton.vue?vue&type=style&index=0&id=34105ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34105ab0",
  null
  
)

export default component.exports